export default {"src":"/_next/static/media/blue-tick-circle.fee59d71.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};